import createCache from '@emotion/cache';

const isBrowser = typeof document !== 'undefined';

// On the client side, Create a cache to collect the CSS-in-JS styles.
// This ensures consistent class name generation between server and client
export function createEmotionCache() {
  let insertionPoint: HTMLElement | undefined;

  if (isBrowser) {
    const emotionInsertionPoint = document.querySelector<HTMLElement>(
      'meta[name="emotion-insertion-point"]',
    );
    insertionPoint = emotionInsertionPoint ?? undefined;
  }

  return createCache({
    key: 'mui-style',
    insertionPoint,
    prepend: true, // Prepend styles to ensure MUI styles load first
    // Ensure this cache is used consistently on both server and client
    stylisPlugins: undefined,
  });
}
